export const CRSV = {
    cta: {
        bigger_unit: 'Need more space?',
    },
};
